import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import { MdDeleteOutline } from 'react-icons/md';

const rowKey = (row) => `${row.propertyNo}||${row.unitNo}||${row.unitRefNo}`;

const SelectedUnitsGrid = ({ rows, onToggleRow, onRemoveRow }) => {
  const selectedCount = rows.filter((r) => r.selected).length;

  return (
    <div className="border-box2 p-3 mt-3">
      <div className="table-responsive" style={{ maxHeight: 400, overflowY: 'auto' }}>
        <table className="table table-bordered align-middle mb-0">
          <thead>
            <tr>
              <th>Select</th>
              <th>Property</th>
              <th>Unit No</th>
              <th>Unit Ref No</th>
              <th>Unit Class</th>
              <th>Status</th>
              <th>Group</th>
              <th>Resv / Lease No</th>
              <th>Total Area</th>
              <th>Rate</th>
              <th>Price</th>
              <th>Source</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={13} className="text-center text-muted p-4">
                  No units added yet. Pick a property and unit above, then press Add.
                </td>
              </tr>
            ) : (
              rows.map((row) => (
                <tr key={rowKey(row)} style={row.hasReceipt ? { background: '#FFF5F5' } : undefined}>
                  <td>
                    <input
                      type="checkbox"
                      checked={!!row.selected}
                      disabled={row.hasReceipt}
                      onChange={(e) => onToggleRow(rowKey(row), e.target.checked)}
                    />
                  </td>
                  <td>
                    {row.hasReceipt && (
                      <FaExclamationTriangle color="#DC3545" className="me-1" title={row.blockedReason || 'This unit cannot be released'} />
                    )}
                    {row.propertyName || row.propertyNo}
                  </td>
                  <td>{row.unitNo}</td>
                  <td>{row.unitRefNo}</td>
                  <td>{row.unitClass}</td>
                  <td>{row.status}</td>
                  <td>{row.groupId}</td>
                  <td>{row.resvNo}</td>
                  <td>{row.totalArea}</td>
                  <td>{row.totalRate}</td>
                  <td>{row.price}</td>
                  <td>{row.source}</td>
                  <td>
                    <MdDeleteOutline size={18} color="#DC3545" style={{ cursor: 'pointer' }} title="Remove" onClick={() => onRemoveRow(rowKey(row))} />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <div className="text-end pt-2 text-muted">{selectedCount} unit(s) selected</div>
    </div>
  );
};

export default SelectedUnitsGrid;
